import { useEffect, useState } from "react";

const headlines = [
  "Get Into Your Dream University",
  "Master the SAT & ACT",
  "Write Essays That Win",
];

export default function HeroSection() {
  const [headlineIndex, setHeadlineIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setHeadlineIndex((prev) => (prev + 1) % headlines.length);
        setFade(true);
      }, 400);
    }, 3200);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative w-full h-[600px] md:h-[720px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ca1ae346a2898b0408419b868fecc569.jpg"
          alt="University campus"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col lg:flex-row items-center lg:items-start gap-12">
        {/* Left */}
        <div className="flex-1 text-white pt-16 lg:pt-24">
          <div className="inline-flex items-center gap-2 bg-amber-500/20 border border-amber-400/40 rounded-full px-4 py-1.5 mb-6">
            <i className="ri-star-fill text-amber-400 text-xs"></i>
            <span className="text-amber-300 text-xs font-semibold tracking-wider uppercase">
              #1 College Prep for USA &amp; Europe
            </span>
          </div>

          <h1
            className="text-4xl md:text-6xl font-bold leading-tight mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            <span
              className="block transition-opacity duration-400"
              style={{ opacity: fade ? 1 : 0 }}
            >
              {headlines[headlineIndex]}
            </span>
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-xl leading-relaxed mb-8">
            Expert SAT/ACT prep, 1-on-1 tutoring, essay coaching, and full admissions strategy — 
            everything your student needs to earn a place at Harvard, Yale, MIT, Oxford, and beyond.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="#booking"
              className="px-8 py-3.5 rounded-full bg-amber-500 text-white font-semibold text-sm hover:bg-amber-600 transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Book Free Consultation
            </a>
            <a
              href="#courses"
              className="px-8 py-3.5 rounded-full border border-white/50 text-white font-semibold text-sm hover:bg-white/10 transition-colors cursor-pointer whitespace-nowrap text-center"
            >
              Explore Programs
            </a>
          </div>

          {/* Mini stats */}
          <div className="flex flex-wrap gap-6 mt-10">
            {[
              { val: "98%", label: "Acceptance Rate" },
              { val: "1550+", label: "Avg SAT Score" },
              { val: "2,400+", label: "Students Placed" },
            ].map((s) => (
              <div key={s.label}>
                <div className="text-2xl font-bold text-amber-400" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {s.val}
                </div>
                <div className="text-white/60 text-xs mt-0.5">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right — floating card */}
        <div className="hidden lg:flex flex-col gap-4 pt-24 min-w-[280px]">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 text-white">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-amber-500">
                <i className="ri-trophy-fill text-white"></i>
              </div>
              <div>
                <div className="text-sm font-semibold">Latest Success</div>
                <div className="text-white/60 text-xs">This week</div>
              </div>
            </div>
            <p className="text-sm text-white/80 leading-relaxed">
              "Olivia scored <strong className="text-amber-400">1580</strong> and got into <strong className="text-white">Harvard</strong>!"
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-5 text-white">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-emerald-500">
                <i className="ri-calendar-check-fill text-white"></i>
              </div>
              <div>
                <div className="text-sm font-semibold">Next Session</div>
                <div className="text-white/60 text-xs">SAT Math Intensive</div>
              </div>
            </div>
            <p className="text-sm text-white/80">
              Spots filling fast — <strong className="text-emerald-400">3 seats left</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 text-white/50 animate-bounce">
        <i className="ri-arrow-down-line text-lg"></i>
      </div>
    </section>
  );
}
